import { useRoute } from '@react-navigation/native'
import { useContext } from 'react'
import { Status } from '../API'
import { ClientService } from './ClientService'
import { ThemeContext } from '../assets/theme/ThemeProvider'
import { monthsOfYear } from '../components/common/DatePicker/useDatePicker'
import moment from 'moment'

const useReportFilterService = () => {
    const route = useRoute()
    const initDate = new Date(moment().startOf('week').valueOf())
    const endDate = new Date(moment().endOf('week').valueOf())
    const { userSub } = useContext<any>(ThemeContext)

    const handleSaveFilterOnLocalStorage = (dateRange: any, members: any, projects: any, clients: any) => {
        localStorage.setItem('dateRange', JSON.stringify(dateRange))
        localStorage.setItem('members', JSON.stringify(members))
        localStorage.setItem('projects', JSON.stringify(projects))
        localStorage.setItem('clients', JSON.stringify(clients))
    }

    const setDataByParams = async () => {
        const params = route.params as any
        const members = params?.members ? params?.members?.split(',') : []
        const projects = params?.projects ? params?.projects?.split(',') : []
        const clients = params?.clients ? params?.clients?.split(',') : []

        const filterByMember: string[] = []
        const filterByProject: string[] = []
        const filterByClient: string[] = []

        const selectedMembers: { code: string }[] = []
        const selectedProjects: { code: string }[] = []
        const selectedClients: { code: string }[] = []

        const dropdownClients: { label: string; code: string }[] = []

        const allClients = await ClientService()
            .getClientsActive(userSub)
            .then((data: any) => {
                return data.filter(e => e.status === Status.ACTIVE)
            })

        const { members: membersLocal, projects: projectsLocal, clients: clientsLocal } = getFiltersByLocalStorage()

        if (membersLocal.length) {
            filterByMember.push(...membersLocal)
            selectedMembers.push(...membersLocal.map(member => ({ code: member })))
        }

        if (projectsLocal.length) {
            filterByProject.push(...projectsLocal)
            selectedProjects.push(...projectsLocal.map(project => ({ code: project })))
        }

        if (clientsLocal.length) {
            filterByClient.push(...clientsLocal)
            selectedClients.push(...clientsLocal.map(client => ({ code: client })))
        }

        dropdownClients.push(...allClients.map(client => ({ label: client.name, code: client.id })))

        if (params?.projects && !projectsLocal.length) {
            filterByProject.push(...projects)
            selectedProjects.push(...projects.map(project => ({ code: project })))
        }

        if (params?.members && !membersLocal.length) {
            filterByMember.push(...members)
            selectedMembers.push(...members.map(member => ({ code: member })))
        }

        if (params?.clients && !clientsLocal.length) {
            filterByClient.push(...clients)
            selectedClients.push(...clients.map(client => ({ code: client })))
        }

        if (!clients.length && !clientsLocal.length) {
            filterByClient.push(...allClients.map(client => client.id))
            selectedClients.push(...(allClients.map(client => ({ code: client.id })) as any))
        }

        return {
            filterByMember,
            filterByProject,
            filterByClient,
            selectedMembers,
            selectedProjects,
            selectedClients,
            dropdownClients,
        }
    }

    const getFiltersByLocalStorage = () => {
        const members = JSON.parse(localStorage.getItem('members') || '[]')
        const projects = JSON.parse(localStorage.getItem('projects') || '[]')
        const clients = JSON.parse(localStorage.getItem('clients') || '[]')
        return { members, projects, clients }
    }

    const getInitialDateRange = () => {
        const params = route.params as any
        const dateRangeFromLocalStorage = JSON.parse(localStorage.getItem('dateRange') || '[]')
        const datesNow: Date[] = []

        if (dateRangeFromLocalStorage.length) {
            datesNow.push(new Date(moment(dateRangeFromLocalStorage[0]).valueOf()))
            datesNow.push(new Date(moment(dateRangeFromLocalStorage[1]).valueOf()))
        }

        if (!dateRangeFromLocalStorage.length && params?.beginDate && params?.finishDate) {
            datesNow.push(new Date(moment(params.beginDate).valueOf()))
            datesNow.push(new Date(moment(params.finishDate).valueOf()))
        }

        if (!params?.beginDate && !params?.finishDate && !dateRangeFromLocalStorage.length) {
            datesNow.push(new Date(moment(initDate).valueOf()))
            datesNow.push(new Date(moment(endDate).valueOf()))
        }

        const label = `${monthsOfYear[Number(datesNow[0]?.getMonth())].text} ${datesNow[0]?.getDate()} - ${
            monthsOfYear[Number(datesNow[1]?.getMonth())].text
        } ${datesNow[1]?.getDate()}`

        return { datesNow, dateRangeLabel: label }
    }

    return { setDataByParams, getInitialDateRange, handleSaveFilterOnLocalStorage }
}

export default useReportFilterService
